import { render, staticRenderFns } from "./scratchdownload.vue?vue&type=template&id=0e00fc05&scoped=true&"
import script from "./scratchdownload.vue?vue&type=script&lang=js&"
export * from "./scratchdownload.vue?vue&type=script&lang=js&"
import style0 from "./scratchdownload.vue?vue&type=style&index=0&id=0e00fc05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e00fc05",
  null
  
)

export default component.exports